import { render, staticRenderFns } from "./BowItemsListBlock.vue?vue&type=template&id=31b5a43c&"
import script from "./BowItemsListBlock.vue?vue&type=script&lang=js&"
export * from "./BowItemsListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default})
